import './style.scss';
import darkBikeIcon from '../../../../assets/icons/micromobility-bike-dark.svg';
import darkScooterIcon from '../../../../assets/icons/micromobility-scooter-dark.svg';
import darkElectricBikeAssistIcon from '../../../../assets/icons/micromobility-bike-electric-assist-dark.svg';
import MicromobilityCheckbox from './components/MicromobilityCheckbox';
import DataUrlHelper from '../../../helpers/data-url.helper';
import { TranslationService } from '../../../services/translation.service';
import { AnalyticsService } from '../../../services/analytics-service';
import { IMicromobilityFilters } from './micromobility-filters.model';

function MicromobilityFilters({
  id,
  selection,
  showSelectionStopAreas,
  className,
  onChange,
}: {
  id: string;
  selection: IMicromobilityFilters;
  showSelectionStopAreas: boolean;
  className?: string;
  onChange: (selection: IMicromobilityFilters) => void;
}) {
  const scootersCollapsableAreaId = `${id}-scooters-collapsable-area`;

  return (
    <div className={`micromobility-filters ${className ?? ''}`}>
      {showSelectionStopAreas && (
        <MicromobilityCheckbox
          text={TranslationService.get('common.stops')}
          checked={selection.showStopAreas}
          className="mb-2"
          onChange={(checked) => {
            AnalyticsService.addEvent(AnalyticsService.LabsMicromobility, 'Filter: Hållplatser', checked ? 'Ja' : 'Nej');
            onChange({ ...selection, showStopAreas: checked });
          }}
        />
      )}
      <MicromobilityCheckbox
        text={`${TranslationService.get('travelplanner.micromobility.formfactor.bicycle.plural')} (Styr & Ställ)`}
        checked={selection.showBikeStations}
        className="mb-2"
        onChange={(checked) => {
          AnalyticsService.addEvent(AnalyticsService.LabsMicromobility, 'Filter: Styr & Ställ', checked ? 'Ja' : 'Nej');
          onChange({ ...selection, showBikeStations: checked });
        }}
        iconSrc={DataUrlHelper.encode(darkBikeIcon)}
      />

      <MicromobilityCheckbox
        id={`${id}-ride-movi-electric-bike-checkbox`}
        text={`${TranslationService.get('travelplanner.micromobility.formfactor.bicycle.electricassist.plural')} (Voi)`}
        checked={selection.showElectricBikesVoi}
        className="mb-2"
        onChange={(checked) => {
          AnalyticsService.addEvent(AnalyticsService.LabsMicromobility, 'Filter: Elcyklar Voi', checked ? 'Ja' : 'Nej');
          onChange({ ...selection, showElectricBikesVoi: checked });
        }}
        iconSrc={DataUrlHelper.encode(darkElectricBikeAssistIcon)}
      />

      <div className="d-flex position-relative justify-content-space-between">
        <MicromobilityCheckbox
          text={`${TranslationService.get('travelplanner.micromobility.formfactor.scooter.plural')} (Ryde, Voi)`}
          checked={selection.showScooters}
          ariaControls={`${id}-ryde-scooters-checkbox ${id}-voi-scooters-checkbox`}
          className="flex-grow-1 flex-md-grow-0 mb-0"
          onChange={(checked) => {
            AnalyticsService.addEvent(AnalyticsService.LabsMicromobility, 'Filter: Elsparkcyklar', checked ? 'Ja' : 'Nej');
            onChange({ ...selection, showScooters: checked, showScootersRyde: checked, showScootersVoi: checked });
          }}
          iconSrc={DataUrlHelper.encode(darkScooterIcon)}
        />
        <button
          type="button"
          className="micromobility-filters__collapse-button btn--as-link btn--with-caret position-absolute collapsed"
          data-bs-toggle="collapse"
          data-bs-target={`#${scootersCollapsableAreaId}`}
          aria-expanded="false"
          aria-controls={scootersCollapsableAreaId}
        >
          <span className="visually-hidden">{TranslationService.get('travelplanner.micromobility.toggleallscooteroperators')}</span>
        </button>
      </div>
      <div className="collapse" id={scootersCollapsableAreaId}>
        <div className="pt-2">
          <MicromobilityCheckbox
            id={`${id}-ryde-scooters-checkbox`}
            text="Ryde"
            checked={selection.showScootersRyde}
            className="ms-4 mb-2"
            onChange={(checked) => {
              AnalyticsService.addEvent(AnalyticsService.LabsMicromobility, 'Filter: Ryde', checked ? 'Ja' : 'Nej');
              onChange({ ...selection, showScooters: selection.showScootersVoi === checked ? checked : undefined, showScootersRyde: checked });
            }}
          />
          <MicromobilityCheckbox
            id={`${id}-voi-scooters-checkbox`}
            text="Voi"
            checked={selection.showScootersVoi}
            className="ms-4 mb-1"
            onChange={(checked) => {
              AnalyticsService.addEvent(AnalyticsService.LabsMicromobility, 'Filter: Voi', checked ? 'Ja' : 'Nej');
              onChange({ ...selection, showScooters: selection.showScootersRyde === checked ? checked : undefined, showScootersVoi: checked });
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default MicromobilityFilters;
